import { render } from "./IdeaBox.vue?vue&type=template&id=7b8ba086"
import script from "./IdeaBox.vue?vue&type=script&lang=ts"
export * from "./IdeaBox.vue?vue&type=script&lang=ts"
script.render = render

export default script